"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulseIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M1 10.1471H4.28847C4.71441 10.1471 5.09361 9.87725 5.23322 9.47483L7.09916 4.09654C7.40521 3.21441 8.64601 3.19577 8.97841 4.06831L15.0937 20.121C15.4172 20.9702 16.6142 20.9826 16.9552 20.1402L20.7471 10.7719C20.9 10.3942 21.2666 10.1471 21.674 10.1471H25", stroke: "black", strokeWidth: "1", strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M1 13.5294H5.38462C5.95255 13.5294 6.45814 13.1697 6.6443 12.6331L9.13222 5.46205C9.54028 4.28587 11.1947 4.26103 11.6379 5.42442L19.7916 26.828C20.223 27.9603 21.8189 27.9768 22.2735 26.8536L27.3295 14.3625C27.5333 13.859 28.0222 13.5294 28.5654 13.5294H33", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0));
};
var PulseIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.PulseIcon = PulseIcon;
//# sourceMappingURL=PulseIcon.js.map